import React, { FC } from 'react';
import { MenuItem } from '@mui/material';
import { jobTypeSelectOptions } from '@efacity/common';
import { FormInputTextProps, FormTextInput } from './FormTextInput';

export const JobPostingTypeSelector: FC<FormInputTextProps> = ({ name, ...props }) => {
  return (
    <FormTextInput name={name} label="Job Type" select {...props}>
      {jobTypeSelectOptions.map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </FormTextInput>
  );
};
